<ng-container *adaptLoading="!meeting">
    <div class="d-flex flex-column">
        @switch (meeting!.status) {
            @case (MeetingStatus.NotStarted) {
                <div class="d-flex flex-column"
                     [innerHTML]="runWorkshopStepData?.notStartedContent"></div>
            }

            @case (MeetingStatus.InProgress) {
                <div class="d-flex flex-column"
                     [innerHTML]="runWorkshopStepData?.inProgressContent"></div>
            }

            @case (MeetingStatus.Ended) {
                <div class="d-flex flex-column"
                     [innerHTML]="runWorkshopStepData?.endedContent"></div>
            }
        }

        <adapt-styled-dashboard-element>
            <div class="d-flex justify-content-center">
                <adapt-meeting-dashboard-card [meeting]="meeting"> </adapt-meeting-dashboard-card>
            </div>
        </adapt-styled-dashboard-element>
    </div>
</ng-container>
